<template>
  <div class="home contenido cookiespagina">
    <div class="container">
    <HelloWorld 
        msg="Uso de las Cookies"
        :imagen="imagen"
     />
     <Titulo titulo="El uso de las Cookies y/o Web Beacons" />
     <div class="row m-0 mb-5 justify-content-center">
        <div class="col-10 my-5">
            <h2 class="mb-4">Al ingresar y continuar con el uso del Sitio de Internet, Usted consiente que RMZ Asesores y Ana Maria Carabes Gonzalez, Roberto Ramirez de Leon y Roberto Ramirez Montaño en delante lo intermediarios, recaben y trate sus datos personales.</h2>
            <p><strong>Los intermediarios le informa a través de estos términos y condiciones, sobre el uso que le da a las Cookies, Web Beacons y/o Tecnología Similar con el propósito de que Usted tenga pleno control y decisión sobre los datos personales que en su caso se traten de Usted.</strong></p>
            <h3 class="mb-4">¿Qué son las Cookies, Web Beacons y/o Tecnología Similar?</h3>
            <p><strong>Definición de Cookie:</strong> Es un archivo de datos que se almacena en el disco duro del equipo de cómputo o del dispositivo de comunicaciones electrónicas de un usuario al navegar en un sitio de internet específico, el cual permite intercambiar información de estado entre dicho sitio y el navegador del usuario. La información de estado puede revelar medios de identificación de sesión, autenticación o preferencias del usuario, así como cualquier dato almacenado por el navegador respecto al sitio de internet.</p>
            <p><strong>Definición de Web Beacons:</strong> Imagen visible u oculta insertada dentro de un sitio web o correo electrónico, que se utiliza para monitorear el comportamiento del usuario en estos medios. A través de éstos se puede obtener información como la dirección IP de origen, navegador utilizado, sistema operativo, momento en que se accedió a la página, y en el caso del correo electrónico, la asociación de los datos anteriores con el destinatario.</p>
            <p>Los sitios de LOS INTERMEDIARIOS se basan en el manejo de Cookies, Web Beacons y/o Tecnología Similar, buscando brindar la mejor experiencia durante su navegación en los diferentes sitios, así como guardar información sobre su acceso para mejorar la seguridad de su cuenta, definir preferencias de contenido y personalizar información en base a los intereses de sus usuarios o seguimiento a sus compras en línea.</p>
            <p>Las Cookies, Web Beacons y Tecnología Similar de LOS INTERMEDIARIOS no pueden ser utilizados para recuperar datos de su disco duro, pasar virus a su ordenador o capturar su dirección de correo electrónico. Algunas de las funciones que las Cookies, Web Beacons y/o Tecnología Similar realizan también se puede lograr mediante la tecnología alternativa, por tanto, se utiliza el término ' Cookies, web Beacons y/o Tecnología Similar en estos términos y condiciones.</p>
            <hr class="mb-5 mt-5" />
            <h3>El uso y manejo de las Cookies, Web Beacons y/o Tecnología Similar por LOS INTERMEDIARIOS</h3>
            <ol>
                <li>Cookies, Web Beacons y/o Tecnología Similar Esenciales
                    <p>Estas Cookies, Web Beacons y/o Tecnología Similar son necesarias para el desempeño básico del sitio de RMZ Asesores; estas habilitan el sistema de autenticación y validación de forma segura así como funciones de prevención de fraudes.</p>
                    <p>Ejemplos de funciones esenciales de una cookie y/o web Beacons:</p>
                    <ul>
                        <li>Identifica si un usuario ha iniciado una sesión segura de manera íntegra.</li>
                        <li>Habilita la validación de un usuario y el manejo de las funcionalidades del sitio de RMZ Asesores</li>
                        <li>Almacena la autenticación y confirma la seguridad de una sesión para los usuarios.</li>
                        <li>Habilita funciones y/o herramientas de prevención de fraude.</li>
                    </ul>
                </li>
                <li>Cookies, Web Beacons y/o Tecnología Similar Complementarias
                    <p>Estas Cookies, Web Beacons y/o Tecnología Similar habilitan funcionalidades adicionales para definir preferencias definidas previamente aplicadas por el usuario.</p>
                    <p>Ejemplos de funciones complementarias de una cookie y/o web Beacons:</p>
                    <ul>
                        <li>Permite restaurar preferencias de contenido previamente definidas.</li>
                        <li>Permite restaurar preferencias de lenguaje y tamaño de texto.</li>
                    </ul>
                </li>
                <li>Cookies, Web Beacons y/o Tecnología Similar de Desempeño 
                    <p>Estas Cookies, Web Beacons y/o Tecnología Similar llevan un seguimiento de los segmentos más visitados así como el uso de sitio web y sus enlaces. Esto permite a RMZ Asesores entender el contenido en el que los usuarios pueden estar más interesados. La información almacenada en estas Cookies, Web Beacons y/o Tecnología Similar no contiene datos personales y/o datos personales sensibles del usuario y es evaluada en términos de tráfico del sitio, no de la información contenida en el mismo.</p>
                    <p>Ejemplos de funciones de desempeño de una Cookies, Web Beacons y/o Tecnología Similar:</p>
                    <ul>
                        <li>Permite el despliegue de diferentes versiones de un mismo sitio, de esa manera podemos evaluar que diseño brinda la mejor experiencia a nuestros usuarios.</li>
                        <li>Habilita el análisis de visitas, tales como el uso de navegador, número de visitas, respuesta a campañas de mercadeo y tendencias de adquisición.</li>
                    </ul>
                </li>
                <li>Cookies, Web Beacons y/o Tecnología Similar de mercadeo 
                    <p>Estas Cookies, Web Beacons y/o Tecnología Similar se aseguran de que el usuario reciba información relevante sobre beneficios y promociones exclusivos de RMZ Asesores.</p>
                    <p>Ejemplos de funciones de una Cookies, Web Beacons y/o Tecnología Similar:</p>
                    <ul>
                        <li>Habilita la comunicación de beneficios y/o mercadeo en línea con el usuario de forma relevante.</li>
                        <li>Mantiene identificado al usuario de manera segura en sus diferentes contenidos, para desplegar información personalizada.</li>
                    </ul>
                </li>
                <li>Cookies, Web Beacons y/o Tecnología Similar de Asociados
                    <p>RMZ Asesores mantiene relación con servicios prestados por agencias de mercadeo asociadas que hacen uso de Cookies, Web Beacons y/o Tecnología Similar para ayudar a proveer al usuario de información relevante en portales externos a RMZ Asesores. Estas agencias de mercadeo se adhieren a los lineamientos de la industria.</p>
                    <p>Toma en consideración, que las distintas plataformas de redes sociales pueden obtener información que como usuario proporciones al hacer uso de su plataforma. RMZ Asesores es participe de este tipo de programas con las redes sociales. Recomendamos consultar el aviso de privacidad de la red social de la cual hagas uso y conozcas las opciones para restringir la información a la cual puedan tener acceso.</p>
                </li>
                <li>Configuración de Cookies, Web Beacons y/o Tecnología Similar en el sitio web de RMZ Asesores
                    <p>Tienes la opción de restringir el uso de Cookies, Web Beacons y/o Tecnología Similar en tu navegador y hacer uso del sitio público de RMZ Asesores. Sin embargo al iniciar una sesión de Servicios en Línea podrás presentar problemas ya que una de las medidas de autenticación de nuestros Servicios es el uso de Cookies, Web Beacons y/o Tecnología Similar.</p> 
                    <p>Recomendación: Al ingresar a otros sitios de Internet fuera de RMZ Asesores, recomendamos que consulte el Aviso de Privacidad y política de Cookies y/o Web Beacons. RMZ Asesores no es responsable por las prácticas de privacidad fuera de su sitio.</p>
                </li>
                <li>Envió de correo electrónico con Cookies, Web Beacons y/o Tecnología Similar 
                    <p>RMZ Asesores hace uso de de Cookies, Web Beacons y/o Tecnología Similar para al enviar un correo electrónico y así identificar si la comunicación es efectiva y relevante. Con esto entender los intereses de sus usuarios y generar contenidos que sean de mayor interés a sus usuarios. Si deseas deshabilitar el uso de de Cookies, Web Beacons y/o Tecnología Similar en tu correo electrónico, recomendamos consultar la configuración del prestador de servicio de correo electrónico.</p>
                </li>
            </ol>
        </div>
     </div>
  </div>
</div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import Imagen from '@/assets/images/fondoAzul.svg'
import Titulo from '@/components/Titulo.vue'
export default {
  name: 'Cookies',
  data() {
      return {
          imagen: Imagen,
      }
  },
  components: {
    HelloWorld,
    Titulo,
  },
  methods: {
      cambiaImagen: function(imagen){
          this.$store.commit('cambiaImagen', imagen);
      },
      ocultaFooter: function(){
          this.$store.commit('ocultaFooter');
      }
  },
  mounted: function(){
      console.log(Imagen);
      this.cambiaImagen(Imagen);
      this.ocultaFooter();
      this.$store.commit('mideMenos', true);
      this.$store.commit('mideMas', false);
      this.$store.commit('estira', false);
  }
}
</script>
<style scoped>
.contenido {
    min-height: 500px;
}
.my-5 {
    margin-bottom: 150px !important;
}
a {
    color: #1900FF;
    font-weight: 600;
}
ol {
    list-style: none;
    counter-reset: section;
}
ol li {
    counter-increment: section;
}
ol li:before {
    content: counters(section, ".")".";
}
ol li ul li:before {
    content:" ";
}
ol li ul li {
    counter-increment: none;
}
ol li {
    padding: 10px 10px 10px 45px;
    font-size: 18px;
    counter-increment: item;
    margin-bottom: 5px;
}
ol li:before {
    margin-right: 10px;
    margin-left: -50px;
    content: counter(item)'.';
    width: 1.2em;
    text-align: left;
    font-size: 30px;
    font-weight: 800;
}
ol ul li {
    padding: 0 0 0 10px;
    font-size: 18px;
    margin-bottom: 0;
}
ol ul li:before {
    margin-right: -10px;
    margin-left: 10px;
    content: counter(item)'.';
    width: 1.2em;
    text-align: left;
    font-size: 30px;
    font-weight: 800;
}
@media only screen and (max-width: 768px){
    ol {
        padding: 0;
    }
    li {
        padding: 10px 0 10px 10px;
    }
}
</style>
<style>
.contGeneral {
   /*height: 450px;*/
}
</style>
